import { ApolloClient, InMemoryCache, HttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import fetch from 'cross-fetch';

/*
The manager's GraphQL client.

Most of this file's callers use it imperatively - client.query / client.mutate from the
~45 modules under queries/ and mutations/ - and those signatures are the same in Apollo
Client 3 as they were in apollo-client 2, so the migration did not touch them. Only the
five components using the React hooks changed import, from @apollo/react-hooks to
@apollo/client.
*/

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem(process.env.AUTH_TOKEN);
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

// This used to be passed as an `onError` option to createHttpLink, which has no such
// option - HttpLink silently ignored it, so none of these errors have ever been logged.
// onError is its own link, and it has to sit ahead of the request links to see their
// failures.
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client GraphQL Error: Message: ${message}, Location: ${locations}, Path: ${path}`));
  }
  if (networkError) console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Network Error: ${networkError}`);
});

const httpLink = new HttpLink({
  uri: process.env.GRAPHQL_SERVER_URL,
  fetch,
});

const client = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  // Kept from the v2 setup. The server's responses are consumed as plain data here rather
  // than normalised by id, and turning __typename back on would change the shape every
  // caller destructures.
  cache: new InMemoryCache({ addTypename: false }),
});

export default client;
